import * as React from 'react';
import { Translation } from 'react-i18next';
import { CustomModalLayout, Heading, Button } from 'wix-style-react';
import { RootStore, withInjectedRootStore } from '../../../../providers';
import s from './ChangePlanModal.scss';

interface ChangePlanSuccessModalProps {
  rootStore: RootStore;
}

const ChangePlanSuccessModalComp: React.FC<ChangePlanSuccessModalProps> = ({
  rootStore,
}) => {
  const { appContext, removeUnloadListener, baseUrl } = rootStore.appStore;
  const { siteGuid } = appContext;

  const goToSuccessPage = () => {
    removeUnloadListener && removeUnloadListener();
    window.location.assign(
      `${baseUrl}dashboard/${siteGuid}/settings/subscriptions/`,
    );
  };

  return (
    <Translation>
      {(t) => (
        <div data-testid='success-modal'>
          <CustomModalLayout
            width='504px'
            dataHook='change_plan_success_modal'
            onCloseButtonClick={goToSuccessPage}
          >
            <div className={s.successModal}>
              <figure className={s.successIcon} />
              <Heading appearence='H3'>
                {t('change_plan.change_plan_modal.change_plan_success_title')}
              </Heading>
              <Button onClick={goToSuccessPage}>
                {t('Advanced.Plans_change.plan_modal_success.button')}
              </Button>
            </div>
          </CustomModalLayout>
        </div>
      )}
    </Translation>
  );
};

export const ChangePlanSuccessModal = withInjectedRootStore(
  ChangePlanSuccessModalComp,
);
